import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';

import { Button } from '../../../components/Button';
import { PaymentContext } from '../PaymentInfoProvider';

import defaultStyle from '../../../styles/formSetStyles.module.css';
import introPageStyles from '../../FormStart/IntroPage/index.module.css';

interface Props {
  onConfirm: (status: api.Payment.IntentStatus | null) => Promise<void>;
}

const ConfirmationPage: React.FC<Props> = ({ onConfirm }) => {
  const { t } = useTranslation();
  let label: string;
  let confirmText: string;
  const paymentInfo = useContext(PaymentContext).data;
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!paymentInfo) {
    label = t(
      `Could not find payment details.\n\nPlease contact the front desk for assistance.`,
    );
    confirmText = 'OK';
  } else {
    switch (paymentInfo.intentStatus) {
      case api.Payment.IntentStatus.RequiresCapture:
      case api.Payment.IntentStatus.Processing:
      case api.Payment.IntentStatus.Succeeded:
        label = t(`Your payment details have already been submitted.`);
        confirmText = 'OK';
        break;
      case api.Payment.IntentStatus.Canceled:
        label = t(
          `Your payment for this visit has been canceled.\n\nPlease contact the front desk for assistance.`,
        );
        confirmText = 'OK';
        break;
      case api.Payment.IntentStatus.RequiresAction:
      default:
        label = t(
          `We were unable to process your payment due to issues confirming your billing details.\n\nPlease contact the front desk for assistance.`,
        );
        confirmText = 'OK';
        break;
    }
  }

  return (
    <div>
      <div className={introPageStyles.Label}>{label}</div>
      <div className={defaultStyle.ButtonSubmitWrapper}>
        <Button
          type="button"
          disabled={isSubmitting}
          children={confirmText}
          onClick={async () => {
            setIsSubmitting(true);
            await onConfirm(paymentInfo?.intentStatus ?? null);
          }}
        />
      </div>
    </div>
  );
};

export default ConfirmationPage;
